import { render, staticRenderFns } from "./ImageNoize.vue?vue&type=template&id=037cab22&scoped=true&"
import script from "./ImageNoize.vue?vue&type=script&lang=js&"
export * from "./ImageNoize.vue?vue&type=script&lang=js&"
import style0 from "./ImageNoize.vue?vue&type=style&index=0&id=037cab22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037cab22",
  null
  
)

export default component.exports